import { createContext } from "react";
import { RycIsProjectModule } from "../Enums/RycIsProjectModule";

interface IProjectContext {
    currentModule: RycIsProjectModule;
    setCurrentModule: (module: RycIsProjectModule) => void;
    menuButtons: React.ReactNode | null;
    setMenuButtons: (buttons: React.ReactNode | null) => void;
    moduleName: string;
}

export const ProjectContext = createContext<IProjectContext>({
    currentModule: RycIsProjectModule.None,
    setCurrentModule: () => { },
    menuButtons: [],
    setMenuButtons: () => { },
    moduleName: ''
});